import { useState } from 'react';
import { useTeamChatSelector } from '@frontend/team-chat-new';
import { Icon, Modal, Heading, Text, TextLink, useModalControl } from '@frontend/design-system';
import { useAppStatus } from '../../../../providers/app-status.provider';
import { TeamChatButton } from './team-chat-button';

export const TeamChatV2RemasteredButton = () => {
  const { modalProps, openModal, closeModal } = useModalControl();
  const isMounted = useTeamChatSelector((ctx) => ctx?.isMounted);
  const isOpen = useTeamChatSelector((ctx) => ctx?.isOpen);
  const unreadMentionsCount = useTeamChatSelector((ctx) => ctx?.unreadMentionsCount);
  const unreadMessagesCount = useTeamChatSelector((ctx) => ctx?.unreadMessagesCount);
  const collapseNav = useTeamChatSelector((ctx) => ctx?.collapseNav);
  const openTeamChat = useTeamChatSelector((ctx) => ctx?.openTeamChat);
  const closeTeamChat = useTeamChatSelector((ctx) => ctx?.closeTeamChat);
  const isDataLoading = useTeamChatSelector((ctx) => ctx?.isDataLoading);
  const [isReloading, setIsReloading] = useState(false);
  const isLoading = isDataLoading === true || isReloading;
  const { teamChat: teamChatStatus } = useAppStatus();
  const somethingIsWrong = !isLoading && isMounted !== true;
  const reset = () => {
    setIsReloading(true);
    closeModal();
    teamChatStatus.retry();
    setTimeout(() => setIsReloading(false), 2000);
  };
  return (
    <>
      <TeamChatButton
        onClick={() => {
          if (somethingIsWrong) return openModal();
          if (isOpen) closeTeamChat();
          else openTeamChat();
          collapseNav();
        }}
        shouldShowDot={!!unreadMentionsCount || !!unreadMessagesCount}
        isActive={isOpen}
        status={somethingIsWrong ? 'warning' : isLoading ? 'loading' : undefined}
      />
      <Modal {...modalProps}>
        <Modal.Header style={{ display: 'flex', alignItems: 'center' }}>
          <Icon name='warning-badge' color='warn' />
          <Heading level={3}>Team Chat is having issues...</Heading>
        </Modal.Header>
        <Modal.Body>
          <Text>
            We have reported the error, but for now maybe try{' '}
            <TextLink onClick={() => reset()}>reloading team chat</TextLink>, or a full{' '}
            <TextLink onClick={() => window.location.reload()}>page refresh</TextLink>?
          </Text>
        </Modal.Body>
      </Modal>
    </>
  );
};
TeamChatV2RemasteredButton.displayName = 'TeamChatV2RemasteredButton';
